module.exports = __webpack_public_path__ + "img/blueRadio.d8017eeb.svg";